module.exports = __webpack_public_path__ + "static/media/SellOnline.7efe641f.svg";